var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "ticketing-steps bg-white border-bottom" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 1 } }, [
              _c("i", { staticClass: "fe fe-grid" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(this.$root.translate("ticketing.step_seats"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 2 } }, [
              _c("i", { staticClass: "fe fe-shopping-bag" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(this.$root.translate("ticketing.step_consessions"))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 3 } }, [
              _c("i", { staticClass: "fe fe-credit-card" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(this.$root.translate("ticketing.step_payment"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 4 } }, [
              _c("i", { staticClass: "fe fe-inbox" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(this.$root.translate("ticketing.step_success"))),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "header mb-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-4 col-12 order-sm-last" }, [
          _c("div", { staticClass: "card card-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _vm.data.showtime
                  ? _c("div", { staticClass: "col" }, [
                      _c("p", { staticClass: "text-truncate mb-0" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.data.showtime.movie?.name) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-truncate mb-0" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.data.showtime.cinema?.name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-truncate mb-0" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.$root.translate("ticketing.session_at")
                            ) +
                            "\n                  "
                        ),
                        _c("strong", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                new Date(_vm.data.showtime.time).toLocaleString(
                                  "vi-VN",
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: undefined,
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  }
                                )
                              ) +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "text-truncate mb-0" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(this.$root.translate("ticketing.screen")) +
                              " "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.data.showtime.room)),
                          ]),
                          _vm._v(
                            "\n                  -\n                  " +
                              _vm._s(this.$root.translate("ticketing.seats")) +
                              "\n                  "
                          ),
                          this.cart.seats.length === 0
                            ? _c("span", [_vm._v("...")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(this.cart.seats, function (seat) {
                            return _c(
                              "span",
                              { staticClass: "font-weight-bold" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(seat.name) +
                                    "\n                  "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card d-none d-md-block" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "h6",
                    {
                      staticClass: "card-title text-uppercase text-muted mb-2",
                    },
                    [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$root.translate("ticketing.order_total")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "h2 mb-0" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          new Intl.NumberFormat("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          }).format(_vm.order.total)
                        ) +
                        "\n                "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flow-actions sticky-footer-bars" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-outline-dark btn-block",
                    class: { disabled: _vm.step !== 2 },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.stepHandler("prev")
                      },
                    },
                  },
                  [_vm._v("\n                ←\n              ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-9" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-dark btn-block",
                    class: {
                      disabled: this.cart.seats.length === 0 || _vm.step === 3,
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.stepHandler("next")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "d-md-none" }, [
                      _vm._v(
                        _vm._s(
                          new Intl.NumberFormat("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          }).format(_vm.order.total)
                        ) + " |"
                      ),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$root.translate("ticketing.continue")) +
                        "\n              "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-8 col-12" }, [
          _vm.errors.length > 0
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.errors, function (error) {
                    return _c("li", [_vm._v(_vm._s(error))])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(1),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.errors.length === 0
            ? _c("div", [
                _vm.step === 1
                  ? _c("div", { attrs: { id: "ticketing-step-0" } }, [
                      _c("div", { staticClass: "ticketing-content" }, [
                        _c("div", { staticClass: "seat-selection" }, [
                          _c("div", { staticClass: "legend" }, [
                            _c("div", [
                              _c("span", { staticClass: "selected" }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$root.translate("ticketing.your_seats")
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", { staticClass: "unavailable" }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$root.translate(
                                      "ticketing.unavailable_seats"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", { staticClass: "seat-area-1 taken" }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$root.translate("ticketing.sold_seats")
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "front" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$root.translate("ticketing.seat_screen")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          this.data.seats.rows.length === 0
                            ? _c("div", { staticClass: "text-center" }, [
                                _vm._m(2),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "text-muted mt-2",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$root.translate(
                                        "ticketing.skip_tickets"
                                      )
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "seats-wrapper-parent" }, [
                            _c("div", { staticClass: "seats-wrapper" }, [
                              _c("div", { staticClass: "seats-wrapper-row" }, [
                                _c("div", { staticClass: "seats seats-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row-wrapper" },
                                    _vm._l(_vm.data.seats.rows, function (row) {
                                      return _c(
                                        "ul",
                                        { staticClass: "seat-row" },
                                        [
                                          _c(
                                            "li",
                                            { staticClass: "rowname wide" },
                                            [_vm._v(_vm._s(row))]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "seats seats-map" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row-wrapper" },
                                    _vm._l(
                                      _vm.data.seats.seats,
                                      function (rows) {
                                        return _c(
                                          "ul",
                                          { staticClass: "seat-row" },
                                          _vm._l(rows, function (seat) {
                                            return seat.id
                                              ? _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      seat.taken
                                                        ? "taken"
                                                        : "available",
                                                      "seat-area-" +
                                                        seat.category.id,
                                                      "seat-size-" + seat.size,
                                                      seat.picked
                                                        ? "selected"
                                                        : "",
                                                      seat.group !== null
                                                        ? "seat-group"
                                                        : "",
                                                      seat.index % 2 === 0
                                                        ? "seat-odd"
                                                        : "seat-even",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.seatPicker(
                                                          seat
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(seat.name) +
                                                        "\n                            "
                                                    ),
                                                  ]
                                                )
                                              : _c("li", {
                                                  staticClass: "spacer",
                                                })
                                          }),
                                          0
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "legend mt-4" },
                            _vm._l(
                              _vm.data.seats.categories,
                              function (category) {
                                return _c("div", [
                                  _c("span", {
                                    class: "seat-area-" + category.id,
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(category.name))]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 2
                  ? _c("div", { attrs: { id: "ticketing-step-1" } }, [
                      _c("div", { staticClass: "ticketing-content" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              { staticClass: "table table-nowrap card-table" },
                              [
                                _vm._m(3),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.data.concessions,
                                    function (concession) {
                                      return _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "ticketing-concession-type",
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "concession-name" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(concession.name) +
                                                  "\n                        "
                                              ),
                                              concession.description !==
                                              concession.name
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-muted d-block",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          concession.description
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "concession-price text-right",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    new Intl.NumberFormat(
                                                      "vi-VN",
                                                      {
                                                        style: "currency",
                                                        currency: "VND",
                                                      }
                                                    ).format(concession.price)
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "ticketing-select text-right",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "quantity-toggle",
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-rounded-circle btn-white",
                                                      class: {
                                                        disabled:
                                                          concession.quantity ===
                                                          0,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.concessionPicker(
                                                            concession,
                                                            "remove"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    staticClass:
                                                      "form-control form-control-flush text-dark text-center d-inline",
                                                    staticStyle: {
                                                      width: "30px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      min: "0",
                                                      max: "10",
                                                      readonly: "",
                                                    },
                                                    domProps: {
                                                      value:
                                                        concession.quantity,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-rounded-circle btn-white",
                                                      class: {
                                                        disabled:
                                                          concession.quantity ===
                                                          10,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.concessionPicker(
                                                            concession,
                                                            "add"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 3
                  ? _c("div", { attrs: { id: "ticketing-step-0" } }, [
                      _vm._m(4),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Có lỗi xảy ra:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-0" }, [
      _vm._v("\n            Vui lòng thử lại hoặc "),
      _c("a", { staticClass: "text-white", attrs: { href: "/support" } }, [
        _vm._v("liên hệ trung tâm hỗ trợ"),
      ]),
      _vm._v(".\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "spinner-border d-block m-auto",
        attrs: { role: "status" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Combo")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Giá tiền")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Số lượng")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border d-block m-auto",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }